import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import { Common } from "../common/CommonTypes";
import ApiProxy from "../../ts/ApiProxy";
import Tools from "../../ts/Tools";
import Popups from "../popups/Popups";

export default class MemberOptionsBlock extends ComponentBase
{
  static instance: MemberOptionsBlock;

  static init($root: JQuery)
  {
    let data: Common.CommonPageData = ApiProxy.getCommonPageData();

    if(data && data.login_state.is_login)
    {
      let info = data.login_state.info;

      let name = Tools.combineName(info.basic.first_name, info.basic.surname);
      if(!name) name = "訪客";

      $root.find(`.name`).text(name);

      $root.find(`.rank`).text(info.rank);
      $root.find(`.number`).text(Tools.formatNumber(info.ezpoint));
      
      // info.picture? this.setUserPicture($root, info.picture): this.setUserPicture($root, Tools.getAvatarName(info.nickname), true);
      (info.basic.picture)? this.setUserPicture($root, info.basic.picture): this.setUserPicture($root, "./static/images/ui/avatar.png");
    }
  }

  static setUserPicture($root: JQuery, src: string, isNameOnly: boolean = false)
  {
    let $btn = $root.find(`.user-icon`);

    if(isNameOnly)
    {
      $btn.text(src);
    }
    else
    {
      // $btn.css("background-image", `url(${src})`);
      let img = new Image();
      img.src = src;
  
      $btn.append(img);
    }
  }

  constructor(elem: ComponentElem)
  {
    super(elem);    
    MemberOptionsBlock.init(this.$root);
    MemberOptionsBlock.instance = this;
  }

  updateName()
  {
    let data: Common.CommonPageData = ApiProxy.getCommonPageData(),
      info = data.login_state.info,
      name = Tools.combineName(info.basic.first_name, info.basic.surname);
    this.$root.find(`.name`).text(name);
  }
}